import { useAuth } from '../../context/AuthContext'

export default function PricingPackageCard({ pkg, onPurchase, compact = false }) {
  const { user } = useAuth()

  const handleClick = () => {
    if (!user) {
      // Trigger login modal
      window.dispatchEvent(new CustomEvent('openLoginModal'))
      return
    }
    onPurchase(pkg)
  }

  if (compact) {
    // Compact version for dashboard quick actions
    return (
      <button
        onClick={handleClick}
        className={`px-4 py-2 rounded-lg font-semibold transition-colors ${
          pkg.popular
            ? 'bg-primary-600 hover:bg-primary-700 text-white'
            : pkg.bestValue
            ? 'bg-blue-600 hover:bg-blue-700 text-white shadow-lg'
            : 'bg-gray-600 hover:bg-gray-700 text-white'
        }`}
      >
        ${pkg.price} → ${pkg.credits} {pkg.bonus > 0 && <span className="text-xs opacity-80">(+{Math.round((pkg.bonus / pkg.price) * 100)}%)</span>}
      </button>
    )
  }

  // Full card version
  return (
    <div
      className={`rounded-xl shadow-lg transition-all overflow-hidden ${
        pkg.popular || pkg.bestValue
          ? 'lg:scale-105 ring-2 ring-primary-500'
          : ''
      } ${
        pkg.popular || pkg.bestValue
          ? 'bg-primary-350 dark:bg-primary-900/30'
          : 'bg-white dark:bg-gray-800'
      }`}
    >
      <div className="p-6">
        {/* Badge */}
        <div className="mb-4">
          {pkg.popular && (
            <div className="inline-block bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-bold">
              POPULAR
            </div>
          )}
          {pkg.bestValue && (
            <div className="inline-block bg-secondary-600 text-white px-3 py-1 rounded-full text-xs font-bold">
              BEST VALUE
            </div>
          )}
        </div>

        {/* Package Name */}
        <h3 className="text-sm text-gray-700 dark:text-gray-300 font-semibold mb-2 uppercase tracking-wide">{pkg.name}</h3>

        {/* Price */}
        <div className="mb-4">
          <div className="text-4xl font-bold text-gray-900 dark:text-white mb-1">${pkg.price}</div>
          <div className={`text-sm font-bold ${
            pkg.bonus > 0 ? 'text-green-800 dark:text-green-300' : 'text-gray-800 dark:text-gray-300'
          }`}>
            {pkg.bonusText}
          </div>
        </div>

        {/* Credits Display */}
        <div className={`rounded-lg p-4 mb-6 ${
          pkg.bonus > 0
            ? 'bg-green-100 dark:bg-green-900/30 border-2 border-green-300 dark:border-green-800'
            : 'bg-gray-100 dark:bg-gray-700 border-2 border-gray-300 dark:border-gray-600'
        }`}>
          <div className={`text-2xl font-bold ${
            pkg.bonus > 0 ? 'text-green-800 dark:text-green-200' : 'text-gray-900 dark:text-gray-100'
          }`}>
            ${pkg.credits}
          </div>
          <div className={`text-xs font-semibold ${
            pkg.bonus > 0 ? 'text-green-800 dark:text-green-200' : 'text-gray-700 dark:text-gray-300'
          }`}>
            in credits
          </div>
          {pkg.bonus > 0 && (
            <div className="text-xs text-green-800 dark:text-green-200 font-semibold mt-1">
              (${pkg.bonus} FREE!)
            </div>
          )}
        </div>

        {/* Button */}
        <button
          onClick={handleClick}
          className={`w-full py-3 rounded-lg font-semibold transition-all ${
            pkg.popular
              ? 'bg-primary-600 hover:bg-primary-700 text-white'
              : pkg.bestValue
              ? 'bg-secondary-600 hover:bg-secondary-700 text-white'
              : 'bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-900 dark:text-white'
          }`}
        >
          Buy Now
        </button>
      </div>
    </div>
  )
}
